import * as React from "react";
import { forwardRef } from "react";
const SvgReports = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M15 4V6.5C15 7.88071 16.1193 9 17.5 9H20M15 4H8C6.89543 4 6 4.89543 6 6V18C6 19.1046 6.89543 20 8 20H18C19.1046 20 20 19.1046 20 18V9M15 4L17 6L20 9",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9 10H13",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9 16H13",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16 16H17",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17 20L5 20C3.89543 20 3 19.1046 3 18L3 12C3 10.8954 3.89543 10 5 10L6 10",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgReports);
export default ForwardRef;
